__turbopack_context__.v({
  "eyebrow": "ServerSupportServicesCardSection-module__tk_yMa__eyebrow",
  "heading": "ServerSupportServicesCardSection-module__tk_yMa__heading",
  "section": "ServerSupportServicesCardSection-module__tk_yMa__section",
  "title": "ServerSupportServicesCardSection-module__tk_yMa__title",
});
